exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box_7830d16{display:inline-block}.inputNumberW_f1112e2{width:80px!important}.inputW_364ff0d{width:300px!important}.flex_06b96a7{display:flex;width:320px;justify-content:space-between;align-items:center}.tableW_ab95daa{width:600px;padding-left:60px;margin:10px 0 20px}.tip_608e91e{color:red}", ""]);

// exports
exports.locals = {
	"box": "box_7830d16",
	"inputNumberW": "inputNumberW_f1112e2",
	"inputW": "inputW_364ff0d",
	"flex": "flex_06b96a7",
	"tableW": "tableW_ab95daa",
	"tip": "tip_608e91e"
};